module.exports = __webpack_public_path__ + "img/close.08a915a2.svg";